module.exports = "<div class=\"page-header\"\n     [style.background-image]=\"background\"\n     [style.height]=\"height\"\n     [class.reverse-padding]=\"reverse\"\n     [class.reverse-padding-top]=\"reverseDir[0]\"\n     [class.reverse-padding-right]=\"reverseDir[1]\"\n     [class.reverse-padding-bottom]=\"reverseDir[2]\"\n     [class.reverse-padding-left]=\"reverseDir[3]\"\n     [style.margin-bottom]=\"margin\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/page-header/page-header.component.html
// module id = ../../../../../src/app/core/page-header/page-header.component.html
// module chunks = main